export default __webpack_public_path__ + "static/media/005-pine trees.8d3315a4.svg";